<template>
<div class="box">
  <headerComponent></headerComponent>
  <section id="hero" class="mt-4" style="min-height: 494px">
    <div class="container">
      <div class="text-left">

        <br>
        <h2>隐私政策</h2>
        <p>上次修改时间：2023年7月31日</p>
        <p>{{ this.common.homeLink }}网站（网站或{{this.common.name}}网站），{{this.common.name}}移动应用程序（软件或{{this.common.name}}软件）和{{this.common.name}} VPN代理服务（以下简称“服务”）由{{this.common.name}}，Inc.（以下简称“ {{this.common.name}}”，“我们”或“我们”）。{{this.common.name}}的政策是尊重您在我们操作网站和{{this.common.name}}软件时可能收集的任何信息的隐私。</p>

        <p>{{this.common.name}}网络是无日志网络。当连接到我们的服务时，{{this.common.name}}不会存储用户的原始IP地址，因此在提供我们服务器的IP地址时无法识别用户。此外，{{this.common.name}}无法披露有关用户在连接到我们的服务时消费的应用程序，服务或网站的信息；因为{{this.common.name}}不会存储此信息。
        </p>

        <br>
        <h4>我们可能收集的信息</h4>
        <p>为了操作我们的服务，{{this.common.name}}可能需要收集以下操作数据。</p>

        <ul>
          <li>用于网络运营和支持的汇总带宽使用情况。</li>
          <li>临时使用数据，以帮助调试服务问题。解决问题后，将不会保留此信息。</li>
          <li>我们执行基于规则的自动化流量管理，以维护和改善我们的服务。应用这些规则可能需要实时分析Internet和数据流量，包括目标网站或IP地址，原始IP地址。但是，由于此信息是实时过程，因此不会保留有关此信息的日志。</li>
          <li>{{this.common.name}}网站使用cookie，跟踪像素和相关技术。Cookies是由我们的平台提供并存储在您的设备上的小型数据文件。我们的网站使用我们或第三方投放的Cookie出于各种目的，包括操作和个性化网站。此外，Cookie还可用于跟踪您如何使用该网站将广告定位到其他网站上。</li>
          <li>当您请求客户支持时，{{this.common.name}}会收集您的电子邮件地址和其他联系信息。我们还会收集有关您的支持请求的信息。该信息用于解决您的查询或服务问题并改善我们的服务。</li>
        </ul>
        <p>当您在设备上安装{{this.common.name}}时，我们可能会自动从您的设备中收集某些信息，包括Android，Apple iOS或其他ID，设备制造商和型号，移动网络浏览器的类型和版本，IP地址，MAC地址，操作系统厂商和版本，位置信息，MCC（移动国家/地区代码）信息。</p>

        <br>
        <h4>广告</h4>
        <p>
          在{{this.common.name}}或我们的任何网站上出现的广告可能会由广告合作伙伴投放给用户，他们可能会设置Cookie。这些Cookie使广告服务器每次向您发送在线广告来收集有关您或使用您计算机的其他人的信息时，广告服务器就可以识别您的计算机。这些信息使广告网络能够投放您认为最感兴趣的定向广告。本隐私政策涵盖{{this.common.name}}使用cookie的范围，不涵盖任何广告商使用cookie的范围。
        </p>

        <br>
        <h4>我们使用信息的方式</h4>
        <p>如果您同意，{{this.common.name}}可能会使用收集到的数据来提供和维护我们的服务，以改善{{this.common.name}}并更好地适应您的需求，以便在{{this.common.name}}上向您发送信息，为您提供更新和升级以及为了通知您有关产品的新闻和动作。
        </p>
        <p>使用{{this.common.name}}，您可以将软件，软件更新或补丁或其他实用程序和工具下载到计算机或支持Internet的设备（“软件”）上。{{this.common.name}}授予您非专有的有限许可，仅可在您将软件提供给您时并根据这些条款将其用于{{this.common.name}}规定的目的。严格禁止未经{{this.common.name}}明确授权以任何方式修改，分发未授权方，进行逆向工程或以其他方式使用软件。
        </p>

        <h6>确认您的订阅标识</h6>
        <p>购买订阅服务时，我们会提示您收集电子邮件以验证订阅标识。</p>

        <h6>确保产品质量</h6>
        <p>当您就任何产品质量问题与我们联系时，我们将收集您设备的特定信息，例如唯一的设备ID，设备类型和操作系统类型。它有助于我们加快问题解决速度并改善产品体验。</p>

        <h6>研究和分析</h6>
        <p>当您成为本服务的用户时，我们将收集有关用户行为和国家/地区代码的统计信息。通过学习和分析统计信息，我们将改善服务和产品以使其更好。</p>

        <br>
        <h4>当我们披露信息时</h4>
        <p>{{this.common.name}}不会将数据转发给第三方。我们明确提及我们不与社交网络或广告网络共享数据的事实。{{this.common.name}}仅出于遵守适用法律，遵守司法命令，防止或调查与我们服务有关的可能不当行为，保护我们服务用户和/或公众的人身安全来转发数据我们的一般业务条款。
        </p>

        <br>
        <h4>隐私政策变更</h4>
        <p>{{this.common.name}}可能会不时更改其隐私政策，并且由{{this.common.name}}自行决定。{{this.common.name}}鼓励访问者或用户经常检查此页面以了解其隐私政策的任何更改。<br>
          上次修订将反映在“最近更新”标题中。对此政策的任何更改将在网站上发布。在本隐私政策中进行任何更改后，您继续访问网站或使用软件即表示您接受此更改。</p>

        <br>
        <h4>联系我们</h4>
        <p>如果您对此通知或我们的隐私惯例有任何疑问或意见，请与我们联系：{{ this.common.email }}</p>



      </div>


    </div>
  </section>
  <footerComponent></footerComponent>
</div>
</template>

<script>
import headerComponent from "@/components/header";
import footerComponent from "@/components/footer";
export default {
  name: "PrivacyPage",
  components:{headerComponent,footerComponent},
}
</script>

<style scoped>
body {
  background-color: #ffffff;
  color: #5b617c;
  font-family: 'Roboto', sans-serif;
  position: relative;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: #282c47;
}

a:hover {
  color: #007bff;
  opacity: .9;
  text-decoration: none;
}

section {
  padding: 20px 0 80px;
}
/*/////////////////////////////////////////
Hero
////////////////////////////////////////*/

#hero {
  text-align: center;
  font-size: 16px;
  margin-top: 10px;

}

#hero h1 {
  font-size: 46px;
  margin-bottom: 30px;
}

#hero p {
  margin-bottom: 20px;
}
</style>